<template lang="pug">
    div.progress-circle-control(:class="{noValue}")
        .progress-circle-control__no-value(v-if="noValue")
        template(v-else)
            div.progress-circle-control__inner
            div.progress-circle-control__number {{ text }}
            div.progress-circle-control__circle
                div.progress-circle-control__bar.progress-circle-control__left
                    div.progress-circle-control__progress(:style='progressLeftStyle')
                div.progress-circle-control__bar.progress-circle-control__right
                    div.progress-circle-control__progress(:style='progressRightStyle')
</template>

<script>
export default {
    name: 'progress-circle-control',
    props: {
        value: {
            type: Number,
            required: true,
        },
    },
    computed: {
        noValue() {
            return this.percent < 0
        },
        percent() {
            return parseInt(this.value) || 0
        },
        text() {
            return `${this.percent}%`
        },
        progressLeftStyle() {
            return {
                'transform': `rotate(${Math.min(180, 360 / 100 * this.percent)}deg)`,
            }
        },
        progressRightStyle() {
            return {
                'transform': `rotate(${Math.max(0, 360 / 100 * this.percent - 180)}deg)`,
            }
        },
    },
}
</script>
